import { Refresh as RefreshIcon, WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import { Box, Button, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useAutograding } from './useAutograding';

type AutogradeRegenerateButtonProps = {
    submissionId: string | null;
    autoGradingEnabled: boolean;
    hasSubmission: boolean;
    hasScoreSet: boolean;
    serverStatus: string | null;
    onCompleted: (
        gradedScore: number,
        gradedFeedback: string | null,
        presentationTranscript: string | null,
        skippedFormatTypes: string[],
    ) => void;
    onStarted: () => void;
};

// The React port of the autograding-regenerate-button directive. The "Regrade" button starts
// autograding and polls for the status. On completion it updates the provisional score and feedback.
export function AutogradeRegenerateButton(props: AutogradeRegenerateButtonProps) {
    const { showButton, isDisabled, inProgress, buttonTooltip, buttonLabel, errorMessage, errorDetails, start } =
        useAutograding(props);

    if (!showButton) return null;

    return (
        <Box sx={{ textAlign: 'end' }}>
            <Tooltip title={buttonTooltip} disableHoverListener={!buttonTooltip}>
                <Box component="span" sx={{ display: 'inline-block' }}>
                    <Button
                        size="small"
                        variant="outlined"
                        disabled={isDisabled}
                        onClick={start}
                        startIcon={inProgress ? <CircularProgress size={14} /> : <RefreshIcon />}
                    >
                        {buttonLabel}
                    </Button>
                </Box>
            </Tooltip>
            {errorMessage && (
                <Typography variant="body2" color="error" title={errorDetails || undefined} sx={{ mt: 1 }}>
                    <WarningAmberIcon sx={{ fontSize: 16, verticalAlign: 'text-bottom', mr: 0.5 }} />
                    {errorMessage}
                </Typography>
            )}
        </Box>
    );
}
